const SkillMatrix = {

    // FIELDS
    "skill_matrix": "Skill Matrix",
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "search": "Search",
    
    // PAGE HEADER
    "list_title": "Skill Matrix",
    "filter_title": "Skill Matrix Filter",
    
    // TABLE HEADER
    "table_name": "Name",
    "table_description": "Description",
    
    // ERROR
    "error_name": "Enter Skill Matrix Name",
    "error_description": "Enter Description",
    "error_status": "Select Status",

}

export default SkillMatrix;

